import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './UploadButton.css';

function UploadButton({ filename, onDelete, index, width = '20%', showDelete = true, isUploading }) {
    const { t: tCommon } = useTranslation('common');
    const safeName = filename ?? "loading";

    // se não tiver ponto, não tenta split
    const ext = safeName.includes('.')
        ? safeName.split('.').pop().toLowerCase()
        : "";
        
    return (
        <div className='file-item-upload' key={index} >
            {isUploading ? (
                <CircularProgress size={13} />
            ) : (
                (() => {
                    if (ext === 'pdf') {
                        return <img src="/imagens/pdf.svg" alt={tCommon("pdfFile")} data-testid="ext"/>;
                    } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
                        return <img src="/imagens/image.svg" alt={tCommon("imageFile")} data-testid="ext"/>;
                    } else if (['xls', 'xlsx'].includes(ext)) {
                        return <img src="/imagens/xls.svg" alt={tCommon("excelFile")} data-testid="ext"/>;
                    } else {
                        return <img src="/imagens/file.svg" alt={tCommon("genericFile")} data-testid="ext"/>;
                    }
                })()
            )}

            <div className="file-name-upload" >{filename}</div>
            {showDelete && (
                <img
                    src="/imagens/x.svg"
                    alt={tCommon("deleteIcon")}
                    className="delete-file-icon"
                    onClick={onDelete}
                />
            )}
        </div>
    );
}

export default UploadButton;